import type { OrderData, ShoppingCartData } from '../data/model';
import { IEvent } from '../shared/EventAggregator';

export class CheckoutStartedEvent implements IEvent {
  constructor(
    public readonly shoppingCart: ShoppingCartData,
    public readonly discountCode: string | undefined,
  ) {}
}

export class CouponAppliedEvent implements IEvent {
  constructor(
    public readonly shoppingCart: ShoppingCartData,
    public readonly discountCode: string | undefined,
  ) {}
}

export class ShippingInfoAddedEvent implements IEvent {
  constructor(
    public readonly shoppingCart: ShoppingCartData,
    public readonly discountCode: string | undefined,
  ) {}
}

export class PaymentInfoAddedEvent implements IEvent {
  constructor(
    public readonly shoppingCart: ShoppingCartData,
    public readonly discountCode: string | undefined,
    public readonly paymentType: string,
  ) {}
}

export class OrderPlacedEvent implements IEvent {
  constructor(
    public readonly order: OrderData,
    public readonly discountCode: string | undefined,
  ) {}
}
